const BASE = process.env.REACT_APP_API_URL || "/api";

// ─────────────────────────────────────────────
// 🔹 Generic API (Login, Signup, etc.)
// ─────────────────────────────────────────────
export const api = async (endpoint, options = {}) => {
  const token = localStorage.getItem("pdfstudio_token");

  const res = await fetch(`${BASE}${endpoint}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    ...options,
  });

  const text = await res.text(); // ✅ SAFE read
  console.log("API RAW RESPONSE:", text);

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch (err) {
    throw {
      message: "Invalid JSON from server",
      raw: text,
    };
  }

  if (!res.ok) {
    throw {
      message: data.error || data.message || "Request failed",
      status: res.status,
      raw: text,
    };
  }

  return data;
};

// ─────────────────────────────────────────────
// 🔹 Upload (generic)
// ─────────────────────────────────────────────
export const apiUpload = async (endpoint, formData) => {
  const token = localStorage.getItem("pdfstudio_token");

  const res = await fetch(`${BASE}${endpoint}`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData,
  });

  const text = await res.text(); // ✅ SAFE read
  console.log("UPLOAD RAW RESPONSE:", text);

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw {
      message: "Invalid JSON from server",
      raw: text,
    };
  }

  if (!res.ok || data.error) {
    throw {
      message: data.error || data.message || "Upload failed",
      raw: text,
    };
  }

  return data;
};

// ─────────────────────────────────────────────
// 🔹 Upload Document (your custom API)
// ─────────────────────────────────────────────
export const uploadDocument = async (file, email) => {
  const formData = new FormData();
  formData.append("document", file);
  formData.append("email", email);

  const res = await fetch(`${BASE}/upload_document.php`, {
    method: "POST",
    body: formData,
  });

  const text = await res.text(); // ✅ SAFE read
  console.log("DOCUMENT UPLOAD RESPONSE:", text);

  let data;
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw {
      message: "Invalid JSON from server",
      raw: text,
    };
  }

  if (!res.ok || data.error) {
    throw new Error(data.error || "Upload failed");
  }

  return data;
};
